module.exports = __webpack_public_path__ + "img/personal-id-card-of-a-man_gris.7235b362.svg";